import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import storage from "@/helpers/storageManage";
import {
  ApplicationMemberAccountInfo,
  ApplicationMemberIsAuth,
  ApplicationMemberStorageToken,
  ApplicationMemberTokenExpiredAt,
} from "@/plugins/setting";

const state = () => ({
  expired_at: storage.getStorage(ApplicationMemberTokenExpiredAt), // the time that token is not valid anymore
  token: storage.getStorage(ApplicationMemberStorageToken),
  accountLogin: {
    isAuth: storage.getStorage(ApplicationMemberIsAuth) || "fail",
    info: storage.getStorage(ApplicationMemberAccountInfo)
      ? JSON.parse(storage.getStorage(ApplicationMemberAccountInfo))
      : {},
  },
});

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
